import { render, staticRenderFns } from "./DevieceDetails.vue?vue&type=template&id=4c40793f&"
import script from "./DevieceDetails.vue?vue&type=script&lang=js&"
export * from "./DevieceDetails.vue?vue&type=script&lang=js&"
import style0 from "./DevieceDetails.vue?vue&type=style&index=0&id=4c40793f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports